import { render } from "./CguForm.vue?vue&type=template&id=30166d00&scoped=true"
import script from "./CguForm.vue?vue&type=script&lang=js"
export * from "./CguForm.vue?vue&type=script&lang=js"

import "./CguForm.vue?vue&type=style&index=0&id=30166d00&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30166d00"]])

export default __exports__